import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  orgId: string;
  userId: string;
  creditLimit: number;
}

export const useUpdateUserCreditLimit = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orgId, userId, creditLimit }: Props) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { userId, creditLimit },
      });
      const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/user-credit-limit`, fetchConfig);
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Failed to update credit limit');
      }
    },
    onSuccess: () => {
      toast.success('Credit limit updated');
      queryClient.invalidateQueries([QueryEntity.Users]);
    },
    onError: () => {
      toast.error('Failed to update credit limit');
    },
  });
};
